
import { defineComponent, onMounted } from 'vue';

import { useNotification } from './useNotification';
import NotificationHeader from './NotificationHeader.vue';
import NotificationList from './NotificationList.vue';

export default defineComponent({
  components: {
    NotificationHeader,
    NotificationList,
  },
  props: {
    withHeader: {
      type: Boolean,
      required: true,
      default: true,
    },
    withFooter: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  setup() {
    const {
      changeVisibilityNotificationModal,
      countUnreadNotifications,
      unreadNotifications,
      setAllNotificationReaded,
      setNotificationAsRead,
      goToNotificationsPage,
    } = useNotification();

    return {
      changeVisibilityNotificationModal,
      countNotifications: countUnreadNotifications,
      notifications: unreadNotifications,
      setAllNotificationReaded,
      setNotificationAsRead,
      goToNotificationsPage,
    };
  },
});
